<script>
  export default {
    props: {
      value: {
        type: String,
        default: "",
      },
      title: {
        type: String,
        default: ''
      },
      titleClass: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: '請輸入關鍵字'
      },
    },
    data() {
      return {
        // submitData: {
        //   data: this.$route.query.query || ''
        // }
      }
    },
    computed: {
      data: {
        get() {
          return this.value 
        },
        set(value) {
          this.$emit('input', value)
        },
      },
    },
    methods: {
      onSubmit() {
        // this.onSearch();
        this.$emit('search', this.data)
      },
      onClearSearch() {
        if(this.$route.name === 'search' && this.$route.query.categoryAlias) {
          this.$route.query.categoryAlias = '*'
        }
        this.onSubmit()
      },
      /* onSearch() {
       if((this.$route.query !== '' && this.submitData.data === '')
       || this.submitData.data !== '') {
       this.$router.push({
       name: this.$route.name,
       params: this.$route.params,
       query: {
       ...this.$route.query,
       query: this.submitData.data || undefined
       }
       })
       }
       } */
    }
  }
</script>
<template>
  <div :class="$style.baseSearch">
    <div
      class="baseSearch__title"
      :class="titleClass"
    >
      {{ title }}
    </div>
    <el-form
      v-model="data"
      @submit.prevent.native="onSubmit"
    >
      <div class="d-md-none d-block my-4 font-medium text-lg">
        搜尋
      </div>
      <div class="d-flex">
        <div class="baseSearch__searchBox"> 
          <el-input
            v-model="data"
            :placeholder="placeholder"
            class="isStyleSearch"
            clearable
            
          ></el-input>
          <!-- @clear="onClearSearch" -->
        </div>
        <div class="baseSearch__submitBox d-md-block d-none">
          <BaseButton
            type="submit"
            class="isStylePrimary isSmall"
          >
            搜尋
          </BaseButton>
        </div>
      </div>
    </el-form>
  </div>
</template>
<style lang="scss" module>
  .baseSearch {
    margin-bottom: 4.375rem;

    @include max-lg {
      margin-bottom: 1rem;
    }

    :global {
      .baseSearch {
        &__title {
          margin-bottom: 1.875rem;
          font-size: 1.5rem;
          font-weight: 500;
        }

        &__searchBox {
          @include max-lg {
            width: 100%;
          }
        }

        &__input {

        }

        &__submit {

        }
      }
    }
  }
</style>
